const Bag = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 9a2.5 2.5 0 0 1 2.5-2.5h9A2.5 2.5 0 0 1 19 9v8a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 17zm2.5-1.5A1.5 1.5 0 0 0 6 9v8a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 17V9a1.5 1.5 0 0 0-1.5-1.5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 6.5a3.5 3.5 0 1 1 7 0v3a.5.5 0 0 1-1 0v-3a2.5 2.5 0 0 0-5 0v3a.5.5 0 0 1-1 0z"
      clipRule="evenodd"
    />
  </>
)
export default Bag
